const debounce = (fn, wait) => {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
};

const fetchConfig = (type = 'json') => {
  return {
    method: 'POST',
    headers: {
      'Content-Type': `application/${type}`,
      'Accept': `application/${type}`
    }
  };
};

$(document).ready(function () {
  try {
    const urlParams = new URLSearchParams(window.location.search);

    
    let maxValueIsURL = Number(urlParams.get('filter.v.price.lte')) > 0

    var minInput = document.getElementById('Filter-Price-GTE');
    var maxInput = document.getElementById('Filter-Price-LTE');
    var priceRange = document.getElementById('price-range');

    var currSymbol = document.querySelector('.facets__price-area').getAttribute('data-currency-symbol');

    var minValue = Number(minInput.getAttribute('min')) || 0;
    var maxValue = Number(maxInput.getAttribute('max')) || 6900;

    var currentMin = Number(urlParams.get('filter.v.price.gte')) ?? minValue;

    var currentMax = maxValueIsURL ? Number(urlParams.get('filter.v.price.lte')) : maxValue;


    $("#price-range").ionRangeSlider({
      type: "double",
      skin: "round",
      grid: true,
      min: minValue,
      max: maxValue,
      from: currentMin,
      to: currentMax,
      prefix: currSymbol,
      onChange: function (data) {
        minInput.value = data.from;
        maxInput.value = data.to;
      },
      onFinish: function (data) {
        console.log(`Min: ${data.from}, Max: ${data.to}`);
        // senkron
        minInput.value = data.from;
        maxInput.value = data.to;
        var form = document.getElementById('FacetFiltersFormAside');
        if (form) {
          form.submit();
        }
      },
    });

    const sliderInstance = $(priceRange).data('ionRangeSlider');
    minInput.addEventListener('input', function () {
      sliderInstance.update({
        from: Number(minInput.value) || minValue,
      });
    });

    maxInput.addEventListener('input', function () {
      sliderInstance.update({
        to: Number(maxInput.value) || maxValue,
      });
    });
  } catch (error) {
    console.error('IonRangeSlider Initialization Error:', error);
  }
});

function calculateDeliveryDate() {
  const today = new Date();
  let daysToAdd = 5;
  let deliveryDate = new Date(today);

  while (daysToAdd > 0) {
    deliveryDate.setDate(deliveryDate.getDate() + 1);
    if (deliveryDate.getDay() !== 0 && deliveryDate.getDay() !== 6) {
      daysToAdd--;
    }
  }

  const options = { weekday: 'short', month: 'long', day: 'numeric' };
  const formattedDate = deliveryDate.toLocaleDateString('en-US', options);
  var deliveryMessage = document.getElementById('delivery-message-date');
  if(deliveryMessage) {
    deliveryMessage.innerText = `${formattedDate}`;
  }
}

calculateDeliveryDate();
